module.exports = __webpack_public_path__ + "img/equation_sqr2-2.0cd48843.svg";